import React from "react"

import Image from "@atoms/Image/Image"
import LShape from "@atoms/LShape/LShape"

import styles from "./CoreImage.module.scss"

const ConditionalWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children

const CoreImage = ({
  image,
  caption,
  align,
  shape,
  variant,
  href,
  linkTarget,
}) => {
  if (!image) {
    return null
  }

  const striptags = require("striptags")
  const camelCase = require("camelcase")

  const width = image?.mediaDetails?.width
  const maxWidth = width ? { maxWidth: `${width}px` } : null

  return (
    <figure
      className={`${styles.figure} ${
        caption ? "base-margin-bottom-large" : "base-margin-bottom-xxl"
      } ${styles[camelCase("" + align)]}`}
    >
      <ConditionalWrapper
        condition={href}
        wrapper={(children) => (
          <a
            href={href}
            target={linkTarget === "_blank" ? "_blank" : "_self"}
            rel="noreferrer"
          >
            {children}
          </a>
        )}
      >
        <div className={styles.align} style={maxWidth}>
          <Image
            image={image}
            widths={[480, 768, 960, 1440]}
            alt={image.altText}
          />
          {shape && variant !== "default" && <LShape color={variant} />}
        </div>
      </ConditionalWrapper>
      {caption && (
        <figcaption style={maxWidth}>{striptags(caption)}</figcaption>
      )}
    </figure>
  )
}

CoreImage.defaultProps = {
  variant: "default",
  align: "wide",
  shape: true,
}

export default CoreImage
